function handleSpin(s) {
  const c0y = s * 3;
  const c1y = s * 9;

  // aq gasatvaliswinebelia sigrdze
  // const time = 300 + s * 20;

  return { c0y, c1y };
}

export default handleSpin;
